// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.brand {\n  font-size: 1.5rem;\n  font-weight: 400;\n  vertical-align: middle;\n}\n\n/* no pointer events */\n.pointer-events-none {\n  pointer-events: none;\n}\n.text-shadow {\n  text-shadow: #a1a1a1 0.1em 0.1em 0.175em;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
